angular.module('kareo.ui.shared.directives.patient-nav', [
  'kareo.ui.shared.directives.patient-nav.directives',
  'kareo.ui.shared.directives.patient-nav.services',
  'kareo.featureSetAreas'])
  .controller('PatientInfoWidgetController', [
    '$scope',
    'PatientNavPatientService',
    function ($scope, PatientNavPatientService) {
      this.init = function () {
        // do any init here
      };
      $scope.patientPhotoUrl = PatientNavPatientService.getPatientPhotoUrl($scope.patientId);
      $scope.showDemographicInfo = function () {
        $scope.isOverDemo = true;
      };
      $scope.hideDemographicInfo = function () {
        $scope.isOverDemo = false;
      };
      $scope.showPatientActions = function () {
        $scope.isOverPatientActions = true;
      };
      $scope.hidePatientActions = function () {
        $scope.isOverPatientActions = false;
      };
      PatientNavPatientService.getPatient($scope.patientId).then((response) => {
        $scope.patient = response;
      });
      PatientNavPatientService.getPatientBalance($scope.patientId).then((response) => {
        $scope.patientBalance = response.remainingPatientAmount;
      });
    }])
  .controller('kPatientNavController', [
    '$scope',
    '$location',
    'authenticatedUser',
    'featureSet',
    'kPatientNavUrlFor',
    'practice',
    'featureSetAreas',
    function ($scope, $location, authenticatedUser, featureSet, urlFor, practice, featureSetAreas) {
      $scope.urlFor = urlFor;
      var activeSubpath = null,
activePath = window.location.pathname;
      $scope.$on('$locationChangeStart', () => {
        activeSubpath = $location.path();
        return activeSubpath;
      });
      $scope.activeRoute = function (pathname, subpath) {
        return activePath.indexOf(pathname) === 0 && (!subpath || subpath === activeSubpath);
      };
      var AUTH__READ = 1, AUTH__WRITE = 2, AUTH__PATIENT_DEMOGRAPHICS = 30, AUTH__PATIENT_CHART = 34, AUTH__NOTES = 35, AUTH__PATIENT_CARE_CHECKLIST = 47, AUTH_HIGHLEVEL_ORDERS = 13, AUTH_HIGHLEVEL_ORDERS_VIEW = 14, AUTH_HIGHLEVEL_ORDERS_RESULT = 15;
      featureSet.load().then((response) => {
        $scope.hasClinical = featureSet.hasClinicalFeatures();
        $scope.hasDocuments = featureSet.hasDocuments();
        $scope.hasKareoBaseProduct = !!response['dark-feature.kareo-base-product'];
        $scope.hasNewNotesList = response['feature-set.new-notes'];
        $scope.hasPatientRecall = response['kareo-office.patient-recare'];
        var hasPatientAlerts = response['dark-feature.patient-alerts'];
        var hasPatientAccountHistory = response['dark-feature.patient-account-history'];
        $scope.hasFlowsheet = response['dark-feature.flowsheets-ui'];
        $scope.featureSet = featureSet;
        $scope.hasTailoredFacesheet = !!response['dark-feature.clinical-tailored-facesheet-configure'];
        $scope.careTeamEnabled = !!response['dark-feature.care-team-members'];

        $scope.showBillingProfiles = function () {
          return $scope.demographicsPriv && !hasPatientAlerts && !hasPatientAccountHistory;
        };

        $scope.showAccount = function () {
          return $scope.demographicsPriv && (hasPatientAlerts || hasPatientAccountHistory);
        };

        $scope.showDocuments = function () {
          return $scope.hasDocuments && $scope.chartPriv && (!$scope.hasKareoBaseProduct || $scope.hasFeatureSetAreaDocuments);
        };

        $scope.showRecall = function () {
          return ($scope.hasPatientRecall && $scope.hasFeatureSetAreaRecall);
        };

        $scope.showFlowsheets = function() {
          return ( $scope.hasFlowsheet );
        };

        $scope.showCareTeam = function() {
          return $scope.careTeamEnabled === true;
        };

        $scope.getAccountUrl = function () {
          if (hasPatientAccountHistory) {
            //  if they have both or just account history, link to account history
            return urlFor.patientPatientAccountHistory($scope.patientId);
          } else if (hasPatientAlerts) {
            return urlFor.patientAlerts($scope.patientId);
          }
            return ''; //  shouldn't happen
        };

        $scope.showClinicalNotes = function () {
          return response['dark-feature.complete-non-clinical-note'] || authenticatedUser.hasRole('Provider') || authenticatedUser.hasRole('Clinical Assistant');
        };

        $scope.showFlowsheetsForAuthorizedUsers = function () {
          return authenticatedUser.hasRole('Provider') || authenticatedUser.hasRole('Clinical Assistant');
        };
      });

      featureSetAreas.load().then((response) => {
        var documentFeatureSetArea = response['feature-set.area.documents'];
        var recallFeatureSetArea = response['feature-set.area.patient-recall'];
        $scope.hasFeatureSetAreaDocuments = !!(documentFeatureSetArea && documentFeatureSetArea.enabled);
        $scope.hasFeatureSetAreaRecall = !!(recallFeatureSetArea && recallFeatureSetArea.enabled);
      });

      authenticatedUser.get().then(() => {
        var check;
        check = authenticatedUser.hasPrivilegeAccess;
        $scope.chartPriv = check(AUTH__PATIENT_CHART, AUTH__READ);
        $scope.notesPriv = check(AUTH__NOTES, AUTH__WRITE);
        $scope.demographicsPriv = check(AUTH__PATIENT_DEMOGRAPHICS, AUTH__READ);
        $scope.careChecklistPriv = check(AUTH__PATIENT_CARE_CHECKLIST, AUTH__WRITE);
        $scope.labsPriv = check(AUTH__PATIENT_CHART, AUTH__WRITE) || check(AUTH_HIGHLEVEL_ORDERS, AUTH__WRITE) || check(AUTH_HIGHLEVEL_ORDERS_VIEW, AUTH__WRITE) || check(AUTH_HIGHLEVEL_ORDERS_RESULT, AUTH__WRITE);
      });

      practice.get()
        .then((results) => {
          $scope.pmEnabled = results.pmenabled;
        });
    }]);
